var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"c-button c-button--youtube"},_vm.$listeners),[_c('font-awesome-icon',{staticClass:"c-button__left-icon",attrs:{"icon":['fab', 'youtube']}}),_vm._v("\n  Connect & Subscribe\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }